import React from 'react';
import { getImageDeliveryUrl } from 'src/utils/imageDelivery';

type BackgroundImageWrapperProps = {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  backgroundImage?: string;
  mobileBackgroundImage?: string;
  overlayColor?: string;
  backgroundColor?: string;
  ariaLabel?: string;
};

const BackgroundImageWrapper: React.FC<BackgroundImageWrapperProps> = ({
  children,
  className = '',
  style = {},
  backgroundImage,
  mobileBackgroundImage,
  overlayColor,
  backgroundColor,
  ariaLabel,
}) => {
  // URLs for the images
  const desktopBg = backgroundImage
    ? `url(https://ik.imagekit.io/spotlio/fetch/tr:w-1920/https://${getImageDeliveryUrl()}/${backgroundImage})`
    : '';
  const mobileBg = mobileBackgroundImage
    ? `url(https://ik.imagekit.io/spotlio/fetch/tr:w-660/https://${getImageDeliveryUrl()}/${mobileBackgroundImage})`
    : desktopBg; // Fallback to desktop if no mobile

  // generate the overlay style if it exists
  const overlayStyle = overlayColor ? `, linear-gradient(${overlayColor}, ${overlayColor})` : '';

  // combine images with overlay
  const mobileBackground = mobileBg ? `${mobileBg}${overlayStyle}` : '';
  const desktopBackground = desktopBg ? `${desktopBg}${overlayStyle}` : '';

  // Estilos base
  const baseStyles: React.CSSProperties = {
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    backgroundBlendMode: 'overlay',
    ...style,
  };

  const hasBackgroundImage = desktopBackground || mobileBackground;
  const divProps = hasBackgroundImage && ariaLabel ? {
    role: 'img' as const,
    'aria-label': ariaLabel,
  } : {};

  // Only include CSS variables if they have values
  const cssVars: Record<string, string> = {};
  if (mobileBackground) cssVars['--mobile-bg'] = mobileBackground;
  if (desktopBackground) cssVars['--desktop-bg'] = desktopBackground;

  return (
    <div style={{ backgroundColor }}>
      <div
        className={`w-full bg-no-repeat ${mobileBackground ? 'bg-[image:var(--mobile-bg)]' : ''} ${desktopBackground ? 'sm:bg-[image:var(--desktop-bg)]' : ''} ${className}`}
        style={{
          ...baseStyles,
          ...cssVars,
        } as React.CSSProperties}
        {...divProps}
      >
        {children}
      </div>
    </div>
  );
};

export default BackgroundImageWrapper;